import styled from 'styled-components';

export const HomeMenu = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 3px;

    @media screen and (max-width: 900px) {
        flex-direction: column;
        margin-bottom: 0px;
    }
`